import React, { CSSProperties, FC } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import styles from './Copy.module.css';

export interface CopyIconProps {
  s?: CSSProperties;
  ariaTitle?: string;
}

const CopyIcon: FC<CopyIconProps> = ({ s = {}, ariaTitle }) => {
  const { iconsPrimaryNone: copyIconStyle } = useTheme();
  const style = {
    ...copyIconStyle,
    ...s,
  };
  const color = style.color ?? '#000';

  return (
    <svg
      role="img"
      className={styles.container}
      style={{ fill: color, ...style }}
      viewBox="0 0 18 18"
    >
      {ariaTitle && <title>{ariaTitle}</title>}
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_68_13094)">
          <rect
            x="6.125"
            y="5"
            width="11.375"
            height="12.5"
            rx="1"
            stroke={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5 4.5L13.5 1.5C13.5 0.671574 12.8284 1.13338e-06 12 1.06096e-06L2.625 2.4137e-07C1.79657 1.68947e-07 1.125 0.671573 1.125 1.5L1.125 12C1.125 12.8284 1.79657 13.5 2.625 13.5L5.625 13.5L5.625 7C5.625 5.61929 6.74429 4.5 8.125 4.5L13.5 4.5Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_68_13094">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </svg>
  );
};

export default CopyIcon;
